import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from "react-scroll-parallax";
import AppearingElement from '../Helper/AppearingElement';
import './main.css';

// Landing Pages Sections 6B and 2D combined
function CombinedBarSection(props) {
    return (
        <section className="bar-section-whatFix">
            <div className="bar-section__background-whatFix" />
            <section className="bar-info-section-whatFix">
                <div className="bar-info-section__header-whatFix">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[-50, 5]}>
                                <Typography variant="h3">
                                    {props.header}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h3">
                                {props.header}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <div className="bar-info-section__content-whatFix">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[20, -50]}>
                                <Typography variant="h5">
                                    {props.content}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h5">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <img alt="Zip Editor Screenshot" src={props.image} className="bar-info-section__graphic-whatFix" />
            </section>
        </section>
    );
}

export default CombinedBarSection;